<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Wall Tower</h2>
        <h3></h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              src="contrology-walltower-highmat-1_1x.jpg"
              src2="contrology-walltower-highmat-1_2x.jpg"
              alt="In-use photo of Contrology Wall Tower and High Mat"
              caption="Contrology Wall Tower"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-walltower-highmat-3_1x.jpg"
              src2="contrology-walltower-highmat-3_2x.jpg"
              alt="In-use photo of Contrology Wall Tower and High Mat"
              caption="Contrology Wall Tower"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-walltower-highmat-5_1x.jpg"
              src2="contrology-walltower-highmat-5_2x.jpg"
              alt="Photo of Contrology Wall Tower"
              caption="Contrology Wall Tower"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-walltower-highmat-6_1x.jpg"
              src2="contrology-walltower-highmat-6_2x.jpg"
              alt="Photo of Contrology Wall Tower and High Mat"
              caption="Contrology Wall Tower and High Mat"
            />
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="Contrology-walltower-video-thumb@1x.jpg"
              src2="Contrology-walltower-video-thumb@2x.jpg"
              alt="Photo of woman using Contrology Wall Tower"
              video
            />
          </photo-grid>

          <cta-button class="cta-button wide" />

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Wall Tower</h2>
              <h3></h3>
              <p>
                The Contrology® Wall Tower is a compact apparatus that anchors firmly to the wall and floor, providing the secure stability necessary to perform a full range of exercises. If space is at a premium in your studio or home gym, the Wall Tower is a small footprint option while enabling the diversity of exercises associated with a traditional Pilates Cadillac apparatus. Also consider adding our optional High Mat to enhance floor exercise with its elevated, padded surface.
              </p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="19-day lead time"
            />

            <p class="post-note">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >2 Year Limited Warranty</icon-link>
              <icon-link
                url="support-walltower"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
            </section>

            <modal-card-large
              v-if="showCardModal"
              @close="showCardModal=false"
            >
            </modal-card-large>

            <cta-button class="cta-button" />
            
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Compact wall system with arm and leg springs (2 each), handles (2), push through bar, push through springs (2), roll back bar, safety chain, and storage chain</li>
              <li>Push Through Bar has flat center that helps determine correct body position in exercises like Teaser and Swan Prep</li>
              <li>Multiple eye bolts allow for precise settings for standing exercises</li>
              <li>Galvanized steel pipes for secure, stability, durability and safety</li>
              <li>Low profile, vertical pipes extend just 18.5”/47cm  from the wall</li>
              <li>Includes (2) wood mounting plates for attachment to both the wall and floor with (4) lag bolts</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Included" animation="reveal">
            <ul class="included">
              <li>Two (2) wood mounting plates for attachment to both the wall and floor with four (4) lag bolts.</li>
              <li>Arm and leg springs (2 each), handles (2), push through bar, roll back bar, safety chain, and storage chain</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <p>D: 19” (48.3cm)</p>
            <p>W: 27” (68.6cm)</p>
            <p>H: 84.5” (214.6cm)</p>
            <p>Weight: 56lbs (25.4kg)</p>
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Compact wall system with arm and leg springs (2 each), handles (2), push through bar, push through springs (2), roll back bar, safety chain, and storage chain</li>
                <li>Push Through Bar has flat center that helps determine correct body position in exercises like Teaser and Swan Prep</li>
                <li>Multiple eye bolts allow for precise settings for standing exercises</li>
                <li>Galvanized steel pipes for secure, stability, durability and safety</li>
                <li>Low profile, vertical pipes extend just 18.5”/47cm  from the wall</li>
                <li>Includes (2) wood mounting plates for attachment to both the wall and floor with (4) lag bolts</li>
              </ul>
              <p><em>Note: Add the <a href="/high-mat">Contrology High Mat</a> to enhance floor exercises and <a href="/spring-sleeves">Spring Sleeves</a> to protect your High Mat.</em></p>
            </tab>
            <tab name="Included">
              <ul class="included">
                <li>Two (2) wood mounting plates for attachment to both the wall and floor with four (4) lag bolts.</li>
                <li>Arm and leg springs (2 each), handles (2), push through bar, roll back bar, safety chain, and storage chain</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims">
              <p>D: 19” (48.3cm)</p>
              <p>W: 27” (68.6cm)</p>
              <p>H: 84.5” (214.6cm)</p>
              <p>Weight: 56lbs (25.4kg)</p>
            </tab>
          </tabs>
        </section>
      </div>

      <section class="accessories-wrapper" id="accessories">
        <h2>Accessories for Wall Tower</h2>
        <div class="accessories">
          <accessory-card
            url="/high-mat"
            product="Wall Tower"
            src="contrology-walltower-highmat-4_1x.jpg"
            src2="contrology-walltower-highmat-4_2x.jpg"
            alt="High Mat product photo"
            caption="High Mat"
          />
          <accessory-card
            url="push-thru-bar-spring"
            product="Wall Tower"
            src="contrology-Walltower-accessory-extraspring-2@1x.jpg"
            src2="contrology-Walltower-accessory-extraspring-2@2x.jpg"
            alt="Push Through Bar Spring product photo"
            caption="Push Through Bar Spring"
          />
          <accessory-card
            url="/spring-sleeves"
            product="Wall Tower"
            src="contrology-Walltower-accessory-springsleeve-2@1x.jpg"
            src2="contrology-Walltower-accessory-springsleeve-2@2x.jpg"
            alt="Spring Sleeves product photo"
            caption="Spring Sleeves"
          />
        </div>
      </section>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/92FZjHSALt8?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import AccessoryCard from "@/components/AccessoryCard.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "walltower",

  metaInfo: {
    title: "Wall Tower - Contrology - Balanced Body",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "",
      },
      {
        property: "og:image",
        content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-walltower-highmat-5_1x.jpg"
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    CtaButton,
    ProdAccordion,
    Tabs,
    Tab,
    AccessoryCard,
    Modal,
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Product",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {},
      products: [
        // Product options
        {
          prodid: 48870362153153,
          partnumber: 18746,
          price: 1850,
          name: "Contrology Wall Tower",
          color: "N/A",
          available: true
        },
        {
          prodid: 48868230824129,
          partnumber: 18768,
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 48868230758593,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 48868230889665,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 48868230955201,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 48868231020737,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 48868231086273,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 48868231151809,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 48868231217345,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 48868231282881,
          partnumber: "18768C",
          price: 2300,
          name: "Contrology Wall Tower with High Mat",
          color: "Wedgewood Upholstery",
          available: true
        },
      ]
    };
  },

  computed: {
    nextIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.51922 0.624325C1.21151 -0.208109 2.33394 -0.208109 3.02623 0.624325L12.4808 11.9927C13.1731 12.8252 13.1731 14.1748 12.4808 15.0073L3.02624 26.3757C2.33395 27.2081 1.21152 27.2081 0.519224 26.3757C-0.173069 25.5432 -0.173069 24.1936 0.519224 23.3612L8.72026 13.5L0.51922 3.63883C-0.173073 2.8064 -0.173073 1.45676 0.51922 0.624325Z" fill="black"/>
</svg>`;
    },

    prevIcon() {
      return `<svg width="13" height="27" viewBox="0 0 13 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.4808 26.3757C11.7885 27.2081 10.6661 27.2081 9.97377 26.3757L0.519221 15.0073C-0.173073 14.1748 -0.173073 12.8252 0.519222 11.9927L9.97377 0.624325C10.6661 -0.208107 11.7885 -0.208107 12.4808 0.624325C13.1731 1.45676 13.1731 2.8064 12.4808 3.63884L4.27974 13.5L12.4808 23.3612C13.1731 24.1936 13.1731 25.5432 12.4808 26.3757Z" fill="black"/>
</svg>`;
    }
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
    initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

.notice {
  border: 1px solid #000000;
  padding: 0 10px;
  margin-bottom: 30px;
}

.notice-wide {
  display: none;
}

.post-note {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

::v-deep .VueCarousel {
  max-width: 900px;
  margin: 0 auto;
}

::v-deep .VueCarousel-dot-container {
  display: block;
  margin-top: 0 !important;
  padding: 0;
  text-align: right;
}

::v-deep .VueCarousel-dot {
  margin-top: 0 !important;
  padding: 0 7px !important;
}

::v-deep .VueCarousel-navigation-button:focus {
  outline: none;
}

::v-deep .VueCarousel-navigation-prev {
  left: 4px;
}

::v-deep .VueCarousel-navigation-next {
  right: 4px;
}

::v-deep .VueCarousel-navigation--disabled {
  opacity: 0.3;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    height: 27px;
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 160%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .table {
    max-width: 650px;
    margin: 0 auto;
  }

  .table table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .table th,
  .table td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .table td {
    height: 50px;
  }

  .table tr th:first-of-type,
  .table tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .notice {
    order: 4;
    margin-bottom: 0;
    margin-top: 10px;
  }

  .links {
    column-count: 1;
    order: 5;
  }

  ::v-deep .modal-card-wrapper {
    top: 100%;
  }

  .icon-link {
    height: 27px;
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 100px 120px auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    max-width: 512px;
  }

  .cta-button,
  .notice {
    display: none;
  }

  .notice-wide {
    display: block;
    border: 1px solid #000000;
    padding: 0 10px;
    margin: 0 32px;
    height: 240px;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    // margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
